import React, { useContext, useEffect, useState} from 'react'
import { useParams, Link } from "react-router-dom"
import { jwtDecode } from "jwt-decode"
import { NormasContext } from '../../context/NormasContext'
import { usePlanes } from '../../context/PlanesContext'
import "./ListaProyectos.scss"
import ModalNewProyecto from '../../components/Modales/Normas/ModalNewProyecto'
import { Oval } from 'react-loader-spinner'
import IllustrationAccess from "../../assets/img/access.png"
// ui
import Card from '../../components/ui/Card'

export const ListaProyectosContext = React.createContext()

function ListaProyectos() {

  const auth = localStorage.getItem("token")
  const jwtParse = jwtDecode(auth)
  const user = jwtParse?.apirest?.objeto

  const { idConsult, id } = useParams()

  const { empresa, fetchEmpresa, fetchEmpresaSinConsultora } = usePlanes()
  const { status, proyectosNormas, fetchProyectosNormas } = useContext(NormasContext)

  const [modalProyecto, setModalProyecto] = useState(false)

  useEffect(() => {
    fetchProyectosNormas({
      user,
      idEmpresa: parseInt(id)
    })

    if(parseInt(idConsult) === 0){
      fetchEmpresaSinConsultora(user, id)
    } else {
      fetchEmpresa(user, idConsult, id)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id])

  const handleModalProyecto = () => {
    setModalProyecto(true)
  }

  let ruta;
  if(user.puesto === 1){
    ruta = `/consultora/${idConsult}/empresa/${id}`
  }
  if(user.puesto === 2){
    ruta = `/empresa/${id}`
  }
  if(user.puesto >= 3){
    ruta = ""
  }

  return (
    <>
      <ListaProyectosContext.Provider value={{ user, id }}>
        <ModalNewProyecto show={modalProyecto} onHide={()=>setModalProyecto(false)} />
        <div className='normas section'>
          <div className='section__header d-flex flex-row align-items-end mb-4'>
            <i className='bi bi-patch-check me-2'></i>
            <h4 className='m-0'><Link to={'/normas'} className='breadcrumb__generico'>Normas ISO</Link> <i className="bi bi-chevron-right"></i> {empresa}</h4>
          </div>
          {status.proyectos.loading ? (
            <div className='loading__normas d-flex flex-column align-items-center justify-content-center'>
              <Oval
                visible={true}
                height="80"
                width="80"
                color="#0d6efd"
                ariaLabel="oval-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
              <p className='fw-medium'>Loading...</p>
            </div>
          ) : (
            <>
              {status.proyectos.error ? (
                <div className='normas--error d-flex flex-column align-items-center justify-content-center rounded-3 mb-4'>
                  <img className='mb-4' src={IllustrationAccess} alt="" />
                  <h2 className='text-danger mb-1'>Oops!</h2>
                  <p>{status.proyectos.error}</p>
                  <Link className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' to={"/normas"}>Regresar a Normas ISO</Link>
                </div>
              ) : (
                <>
                  {proyectosNormas?.objeto?.length === 0 ? (
                    <div className='normas--empty d-flex flex-column align-items-center justify-content-center rounded-3 p-4'>
                      <h2 className='text-blue-500 fw-semibold mb-1 text-center'>No tienes proyectos aún.</h2>
                      {/* AGREGAR EVIDENCIAS - PUESTO ADMIN CONSULTORA Y GERENTE */}
                      {(user?.puesto === 1 || user?.puesto === 2 || user?.puesto === 3) && (
                        <>
                          <p className='mb-3 text-center'>Para comenzar, crea tu primer proyecto:</p>
                          <button className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' 
                            onClick={handleModalProyecto}>
                              + agregar proyecto
                          </button>
                        </>
                      )}
                    </div>
                  ) : (
                    <div className='proyectos scroll--y'>
                      {proyectosNormas?.objeto?.map((p) => (
                        <Card 
                          key={p.id_proyecto_norma}
                          nombre={p.nombre}
                          estado={p.estado}
                          usuario={p.Creador?.nombre}
                          fecha={p.fecha_inicio?.replace(/-/g, '/').split("/").reverse().join("/")}
                          link={`/normas${ruta}/proyecto/${p.id_proyecto_norma}`}
                          progreso={p.porcentaje}
                        />
                      ))}
                      {(user?.puesto === 1 || user?.puesto === 2 || user?.puesto === 3) && (
                        <>
                          <div className='card--new p-3 d-flex flex-column align-items-center justify-content-center rounded-3'>
                            <button className='btn btn-primary rounded-pill shadow-sm fw-medium px-3' 
                              onClick={handleModalProyecto}>
                                + agregar proyecto
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </div>
      </ListaProyectosContext.Provider>
    </>
  )
}

export default ListaProyectos